<div class="container-fluid">
  <h4 id="uppers">Graphe/ Programme</h4>
  <div class="d-flex justify-content-end">

  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th class="text-start"> Programme</th>
                  <th class="text-center"> Poids </th>
                  <th class="text-center"> Mt. Fonds Propres</th>
                  <th class="text-center"> Mt. Budget National</th>
                  <th class="text-center">Total</th>
                  <th class="text-center">%</th>
                  <th class="text-center">RANG</th>
                </tr>
              </thead>
              <tbody>
                <!-- Ligne des projets -->
                <tr *ngFor="let item of projets; let i = index">
                  <td class="text-start" >{{ item.nom_programme}}</td>
                  <td class="text-center">{{item.poids}}</td>
                  <td  class="text-end uppers_c">{{ item.mt_financement_fond_propre | formatMoney:null }}</td>
                  <td  class="text-end uppers_c">{{ item.mt_financement_etat | formatMoney:null }}</td>
                  <td  class="text-end uppers_c">{{ item.total | formatMoney:null }}</td>
                  <td class="text-end uppers_c">
                    {{ item.pourcentage && !isNaN(+item.pourcentage) ? (item.pourcentage | number: '1.0-2') : 0 }}%
                  </td>
                  <td id="uppers" class="text-center">{{ i + 1 }}</td>
                </tr>

                <!-- Ligne des totaux -->
                <tr class="table-total">
                  <td class="text-start fw-bold">TOTAL</td>
                  <td class="text-center fw-bold">-</td>
                  <td id="uppers" class="text-end fw-bold">{{ totalFinancementFondPropre | formatMoney:null }}</td>
                  <td id="uppers" class="text-end fw-bold">{{ totalFinancementEtat | formatMoney:null }}</td>
                  <td id="uppers" class="text-end fw-bold">{{ totalGeneral | formatMoney:null }}</td>
                  <td class="text-center fw-bold">-</td>
                  <td class="text-center fw-bold">-</td>
                </tr>

              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 class=" text-center" id="uppers">Répartition des Financements par Programmes</h2>
      <div class="container mt-5 d-flex justify-content-center">
        <div class="row">
          <!-- Use col-md-8 to ensure it occupies 8 columns -->
          <div class="col-md-12 col-sm-6">
            <div class="card">
              <div class="card-body">
                <apx-chart *ngIf="simplePieChart" class="apex-charts" dir="ltr" [series]="simplePieChart.series"
                  [chart]="simplePieChart.chart" [labels]="simplePieChart.labels" [legend]="simplePieChart.legend"
                  [colors]="simplePieChart.colors" [responsive]="simplePieChart.responsive">
                </apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-5 d-flex justify-content-center" *ngIf="isLoading">
        <div class="mt-4 col-md-4">
          <p-skeleton shape="circle" size="25rem"></p-skeleton>
        </div>
      </div>
    </div>

  </div>

  <p-confirmDialog />
  <p-toast />
  <ngx-ui-loader></ngx-ui-loader>